export interface AirbridgeProject {
  projectId: string;
  displayName: string;
  appName: string;
}

export const AIRBRIDGE_PROJECTS: AirbridgeProject[] = [
  { projectId: "bunkerDefense", displayName: "벙커 디펜스", appName: "bunkerdefense" },
  { projectId: "wiggleDefender", displayName: "꿈틀 수비대", appName: "wiggledefender" },
  { projectId: "spaceMinions", displayName: "스페이스 미니언", appName: "spaceminions" },
  { projectId: "battleshipgo", displayName: "배틀 쉽 고", appName: "battleshipgo" },
  { projectId: "starDefense", displayName: "스타 디펜스", appName: "stardefense" },
];

export function getAirbridgeToken(appName: string): string | null {
  const envKey = `AIRBRIDGE_TOKEN_${appName.toUpperCase()}`;
  return process.env[envKey] || null;
}
